import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output,
  TemplateRef,
} from "@angular/core";
import { BsDropdownDirective, BsDropdownModule } from "ngx-bootstrap/dropdown";
import { AccountantService } from "../../../accountant/accountant.service";
import { Job } from "../../../accountant/jobs-and-tasks/job.model";
import { TagComponent } from "../tag.component";
import { FormsModule } from "@angular/forms";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgTemplateOutlet } from "@angular/common";

@Component({
  selector: "ch-tag-add",
  templateUrl: "./tag-add.component.html",
  styleUrls: ["./tag-add.component.scss"],
  imports: [
    BsDropdownModule,
    NgTemplateOutlet,
    TooltipModule,
    FormsModule,
    TagComponent,
  ],
})
export class TagAddComponent implements OnInit, OnChanges {
  @ViewChild("dropdown") dropdown: BsDropdownDirective;
  @Input() existingTags: any[] = [];
  @Input() workspace;
  @Input() job: Job;
  @Output() tagClick = new EventEmitter();
  @Input() removeTagOnClick = true;

  @Input() extension: TemplateRef<any>;
  @Input() icon: TemplateRef<any>;
  @Input() autoClose = true;

  @Output() andOrFilterChanged = new EventEmitter();
  addedTags: any[] = [];

  andOrFilter = "or";

  search: string = "";

  tags: any[] = [];
  all_tags: any[] = [];

  constructor(private accountantService: AccountantService) {}

  ngOnInit(): void {
    this.accountantService.getAccountingCompanyTags().then((res: any) => {
      this.all_tags = res;
      this.tags = res;

      this.filterExistingTags();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["existingTags"]) {
      this.filterExistingTags();
    }
  }

  filterExistingTags() {
    if (this.existingTags != null) {
      this.tags = this.all_tags.filter((t) => {
        return !this.existingTags.find((et) => {
          return t.uuid === et.uuid;
        });
      });
    }
  }

  filterSearchTags() {
    this.tags = this.all_tags.filter((t) => {
      return t.name.toLowerCase().includes(this.search.toLowerCase());
    });

    this.tags = this.tags.filter((t) => {
      return !this.addedTags.find((at) => {
        return t.uuid === at.uuid;
      });
    });
  }

  _tagClick(tag) {
    this.tagClick.emit(tag);

    if (this.removeTagOnClick) {
      this.tags = this.tags.filter((t) => {
        return t.uuid !== tag.uuid;
      });
    }
  }

  setFilter(filter: string) {
    this.andOrFilter = filter;
    this.andOrFilterChanged.emit(this.andOrFilter);
  }
}
